import { themeColor } from "./_helpers";

export const iconToken = themeColor({
  base: "{colors.primary.600}",
  _themeBlack: "{colors.neutral.200}",
  _themeWhite: "{colors.primary.700}",
});
